import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../../auth/AuthProvider';
import { DashboardLayout } from '../../components/Layout';

const navItems = [
  { to: '/platform', label: 'Overview', end: true },
  { to: '/platform/shops', label: 'Shops' },
  { to: '/platform/staff', label: 'Staff' },
];

export default function PlatformLayout() {
  return (
    <AuthProvider mode="platform">
      <DashboardLayout title="Platform" navItems={navItems}>
        <Outlet />
      </DashboardLayout>
    </AuthProvider>
  );
}
